import { AppIcons } from "../../../data/appIcons";
import { GridColumnType } from "../../../data/gridColumnType";

export const BoardMemberManagementConfig = {
  columns: [
    {
      name: "Name",
      fieldName: "name",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Email Address",
      fieldName: "email",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Board Appointment",
      fieldName: "typeOfMember",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Actions",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: true,
      },
      // UPDATE
      customAction: [
        {
          name: "VIEW",
          // iconName: AppIcons.copyIcon,
          iconName: AppIcons.editIconNew,
          onViewAction: (data) => {
            // console.log("Selected:", data.memberName);
          },
        },
      ],
    },
  ],
};
